import * as React from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

export const MOTION_OVERRIDE_TOOLTIP =
  "Set on this camera; overrides the site's motion setting. Change it in Edit Camera → Motion.";

/**
 * Marker for the Site About cameras table's Use Motion cell: shown only when
 * the camera carries its own `use_motion_override` (true/false). null or a
 * missing field (older admin builds) renders nothing, so the cell is unchanged.
 */
export const MotionOverrideMarker = ({
  override,
}: {
  override?: boolean | null;
}) => {
  if (typeof override !== "boolean") return null;
  return (
    <Tooltip
      title={MOTION_OVERRIDE_TOOLTIP}
      placement="top"
      sx={{ fontSize: "15px", fontFamily: "mulish" }}
    >
      <Chip
        data-testid="motion-override-marker"
        label={override ? "Motion (camera)" : "Always stream"}
        size="small"
        variant="outlined"
        sx={{ fontFamily: "Mulish", ml: 1, fontSize: "11px", height: 20 }}
      />
    </Tooltip>
  );
};
